`<template>
  <div
    class="d-flex justify-center slide-page"
    :class="[contentHtml ? 'align-center' : null]"
    :style="{
      height: `calc(100% - ${assistantHeaderHeight + 48 + 32}px)`,
      maxWidth: '100vw',
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : null,
      backgroundSize: 'contain',
      backgroundPosition: 'top 4rem center'
    }">
    <div>
      <div v-if="currentContent.title" class="slide-title-container">
        <span
          class="slide-title"
          v-text="currentContent.title">
        </span>
        <template v-if="currentScene.subtitle">
          -
          <span class="slide-subtitle" v-text="currentScene.subtitle"></span>
        </template>
      </div>
      <br>
      <div
        ref="slideContent"
        class="slide-content"
        :class="[onlyImage ? 'slide-only-image' : null]"
        v-html="contentHtml"
      />
      <div class="slide-chips-container">
        <span
          class="slide-chip"
          v-for="(suggestion, i) in suggestions"
          :key="i"
          @click="sendQuery(suggestion)"
          v-text="suggestion"
        />
        <!-- <v-chip
          v-for="(suggestion, i) in suggestions"
          :key="i"
          @click="sendQuery(suggestion)"
        >
          {{suggestion}}
        </v-chip> -->
      </div>
    </div>
  </div>
</template>

<script>
const marked = require('marked')
const { delay } = require('@/lib/util')
const { assistant, Assistant } = require('@/lib/Assistant')
const SlidePage = require('@/lib/action/SlidePage')

const slidePage = new SlidePage({
  id: 'test',
  contents: [
    {
      title: null,
      scenes: [
        {
          speech: '-',
          content: `![報名資訊](${require('@/assets/img/mirror/main.jpeg')})`
        }
      ]
    },
    {
      title: '課程內容',
      keywords: ['課程資訊', '課程', '內容'],
      scenes: [
        {
          speech: '好的，請看',
          content: `
+ 發音健檢｜幫助學員檢視發音，並進行改善。
+ 肢體如何幫助說話｜透過肢體放鬆，讓錄音更順利。
+ 聲音表演3W｜提昇學員的聲音演繹能力。
+ 變聲小撇步｜讓學員輕鬆切換不同角色。
+ 實際錄製｜進棚錄製自己的聲音作品。
`.trim()
        }
      ]
    },
    {
      title: '講師陣容',
      keywords: ['老師有誰', '講師', '老師', '陣容', '有誰'],
      scenes: [
        {
          subtitle: '盧怡君老師',
          speech: '我們有盧怡君老師',
          content: `
![盧怡君老師](https://img.mirrorfiction.com/n/6/9/369/185844/8b8a207d-4761-46cf-adb0-30faeea56903.jpeg)
+ Siri第一代發聲人，有「嬉力姐」之稱。
+ 配音資歷25年，包含廣告、有聲書及教材錄製等。
+ 為華視、中廣、POP Radio聲音表情老師。
`.trim()
        },
        {
          subtitle: '袁光麟老師',
          speech: '袁光麟老師',
          content: `
![袁光麟老師](https://img.mirrorfiction.com/n/6/9/369/191761/b8c63af4-e68d-4292-a16f-99811bcee51d.jpeg)
+ 五座金鐘獎得主5座金鐘獎得主，多次擔任金鐘獎評審與頒獎人。
+ 幕後配音及聲音導演資歷近40年。
+ 現為世新大學廣播電視電影系兼任副教授。
`.trim()
        },
        {
          subtitle: '吳維緯老師',
          speech: '還有吳維緯老師',
          content: `
![吳維緯老師](https://img.mirrorfiction.com/n/6/9/369/185896/69d1ef7c-95c7-4167-a60a-3c903992c877.jpeg)
+ 劇場編導、舞監、演員。
+ 曾任北藝大、交大、中央等大學戲劇講師，
+ 現為樹德科技大學表演藝術系兼任助理教授、藝起文化基金會執行長。
`.trim()
        }
      ]
    },
    {
      title: '報名資訊',
      keywords: ['如何報名', '報名', '報名方法', '報名方式', '報名資訊'],
      scenes: [
        {
          speech: '現在只要搜尋鏡好聽學院。或者掃描QRcode。就可以報名了。',
          content: `![報名資訊](${require('@/assets/img/mirror/qrcode.jpeg')})`
        }
      ]
    }
  ]
})
export default {
  computed: {
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    },
    currentContent(){
      if(this.slidePage){
        return this.slidePage.contents[this.currentContentIndex]
      }
      return null
    },
    currentScene(){
      if(this.currentContent){
        return this.currentContent.scenes[this.currentSceneIndex]
      }
      return null
    },
    suggestions(){
      if(this.slidePage){
        let suggestions = []
        for(let content of this.slidePage.contents){
          if(this.currentContent !== content && content.title){
            if(content.title && content.keywords[0]){
              suggestions.push(content.keywords[0])
            }
          }
        }
        return suggestions
      }
      return []
    },
    contentHtml(){
      if(this.currentScene && this.currentScene.content){
        return marked(this.currentScene.content)
      }
      return null
    },
    backgroundImage(){
      if(this.currentScene && this.currentScene.background.type === 'image'){
        return this.currentScene.background.value
      }
      return null
    }
  },
  watch: {
    contentHtml(){
      this.checkContentIsOnlyImage()
    }
  },
  data() {
    return {
      currentContentIndex: 0,
      currentSceneIndex: 0,
      onlyImage: false,
      slidePage
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.$store.commit('appbar/toggle', false)
      this.$callback = assistant.addCallback('$ANY', (data)=>{
        console.log('assistant receive', data.query)
        if(data.query){
          let pageMove = this.detectPageMoveKeyword(data.query)
          if(pageMove){
            // 說上一頁或下一頁的情況
            this.currentSceneIndex += pageMove
          }else{
            let results = this.slidePage.searchContent(data.query)
            if(results.length > 0){
              let result = results[0]
              this.currentContentIndex = result.contentIndex
              this.currentSceneIndex = 0
              this.cancelSlideTimer()
              this.slideStart()
              this.checkContentIsOnlyImage()
            }
          }
        }
      })
      this.$ttsCallback = assistant.addTTSCallback((mark)=>{
        if(mark === 'END'){
          this.$emit('tts-end')
        }
      })
      assistant.setup()
      this.checkContentIsOnlyImage()
    })
  },
  beforeDestroy(){
    let success = assistant.removeCallback('$ANY', this.$callback)
    assistant.removeTTSCallback(this.$ttsCallback)
    console.log('remove callback', success)
    this.cancelSlideTimer()
  },
  methods: {
    detectPageMoveKeyword(query){
      let units = ['頁', '位', '章', '張', '個']
      for(let unit of units){
        if(query === '上一' + unit){
          return -1
        }
      }
      for(let unit of units){
        if(query === '下一' + unit){
          return 1
        }
      }
      // switch(query){
      //   case '上一頁':
      //   case '上一個':
      //   case '上一位':
      //     return -1
      //   case '下一頁':
      //   case '下一個':
      //   case '下一位':
      //     return 1
      // }
      return 0
    },
    sendQuery(text){
      if(!this.watting){
        this.watting = true
        return assistant.query(text).then(()=>{
          this.watting = false
        })
      }
      return Promise.resolve()
    },
    startTTS(text = null){
      if(!text){
        text = this.currentScene.speech || this.currentScene.content
      }
      return assistant.startTTS(text)
    },
    checkContentIsOnlyImage(){
      console.log('change contentHtml')
      if(this.contentHtml && this.contentHtml.length > 0 && this.$refs['slideContent']){
        this.$nextTick(()=>{
          this.onlyImage = this.$refs['slideContent'].textContent.trim().length === 0
          console.log('this.onlyImage', this.onlyImage, this.$refs['slideContent'].textContent.trim())
        })
      }
    },
    async slideStart(){
      this.cancelSlideTimer()
      this.$off('tts-end')
      if(this.currentContent.mode === 'auto'){
        this.$once('tts-end', ()=>{
          this.$slideTimer = setTimeout(()=>{
            this.nextScene({ loop: true })
          }, this.currentContent.switchInterval)
        })
      }
      this.startTTS()
    },
    async nextScene(opts = {}){
      if(this.currentContent.scenes.length > this.currentSceneIndex + 1){
        this.currentSceneIndex += 1
        if(opts.loop){
          this.$once('tts-end', ()=>{
            this.$slideTimer = setTimeout(
              ()=>{
                this.nextScene({ loop: true })
              },
              this.currentContent.switchInterval
            )
          })
          this.startTTS()
        }
      }else{
        if(opts.loop){
          this.cancelSlideTimer()
        }
      }
    },
    cancelSlideTimer(){
      if(this.$slideTimer){
        window.clearTimeout(this.$slideTimer)
        this.$slideTimer = null
      }
    }
  }
}
</script>
<style>
html{
  font-size: 14sp;
}
body{
  overflow: hidden !important;
}
.slide-page{
  padding-right: 30px;
  padding-left: 30px;
}
.slide-title-container{
  padding-right: 16px;
}
.slide-title{
  font-size: 2rem;
}
.slide-subtitle{
  font-size: 1.5rem;
}
.slide-content{
  padding-right: 30px;
  padding-left: 30px;
  font-size: 1.3rem;
  text-align: left;
}
.slide-content p{
  text-align: center;
}
.slide-content ul li{
  text-align: left;
}
.slide-content img{
  max-width: 100%;
  max-height: 50vh;
}
.slide-only-image img{
  max-width: 100% !important;
  max-height: calc(90vh - 100px) !important;
  width: 100%;
  height: 100%;
}
.slide-chips-container{
  position: fixed;
  bottom: 0px;
  left: 0px;

  padding-top: 16px;
  padding-bottom: 16px;

  background-color: rgb(25, 25, 25);

  text-align: center;
  width: 100vw;
  overflow-y: hidden;
  overflow-x: scroll;
  scrollbar-width: 0px;
}
.slide-chips-container .slide-chip{
  padding: 4px 8px 4px 8px;
color:  #ef98e8;
  border-style: solid;
  border-color: #33cbfe;
  border-radius: 8px;
  border-width: 1px;
}
.slide-chips-container .slide-chip:hover{
  opacity: 0.7;
  cursor: pointer;
}
.slide-chips-container .slide-chip:not(:last-child){
  margin-right: 24px;
}
.slide-chips-container::-webkit-scrollbar {
  width: 0px;
  display: none;
}
.slide-chips-container::-webkit-scrollbar-track{
  display: none;
}
/* Handle */
.slide-chips-container::-webkit-scrollbar-thumb{
  display: none;
}
.slide-chips-container::-webkit-scrollbar-corner{
  display: none;
}
.slide-chips-container::-webkit-scrollbar-track-piec{
  display: none;
}
</style>
